<script>
  import Landing from "./components/Landing.svelte";
  import Publication from "./components/Publication.svelte";
  import Authors from "./components/Authors.svelte";
  import Opinions from "./components/Opinions.svelte";
  import Download from "./components/Download.svelte";
  import Footer from "./components/Footer.svelte";
  import Nav from "./components/Nav.svelte";
  import Patrons from "./components/Patrons.svelte";
</script>

<main>
    <Nav/>
    <Landing/>
    <Patrons/>
    <Opinions/>
    <Publication/>
    <Authors/>
    <Download/>
    <Footer/>
</main>

<style>
</style>
